import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import useTheme from '../../shared/hooks/useTheme';
import '../styles/userMenu.css';

const SunIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden {...props}>
    <path d="M12 2v2m0 16v2M4 12H2m4.314-5.686L4.9 4.9m12.786 1.414L19.1 4.9M6.314 17.69 4.9 19.104m12.786-1.414 1.414 1.414M22 12h-2m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" />
  </svg>
);

const MoonIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden {...props}>
    <path d="M22 15.844a10.424 10.424 0 0 1-4.306.925c-5.779 0-10.463-4.684-10.463-10.462 0-1.536.33-2.994.925-4.307A10.464 10.464 0 0 0 2 11.538C2 17.316 6.684 22 12.462 22c4.243 0 7.896-2.526 9.538-6.156Z" />
  </svg>
);

const MonitorIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden {...props}>
    <path d="M8 21h8m-4-4v4m-5.2-4h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17Z" />
  </svg>
);

const THEME_OPTIONS = [
  { value: 'light', label: 'Light', Icon: SunIcon },
  { value: 'dark', label: 'Dark', Icon: MoonIcon },
  { value: 'system', label: 'System', Icon: MonitorIcon },
];

const axios = require('axios').default;

const UserMenu = ({
  csrfToken,
  currentUser,
  team,
  myTicketsLink,
  teamMemberships
}) => {
  const { theme, setTheme } = useTheme();
  const CurrentThemeIcon = (THEME_OPTIONS.find((opt) => opt.value === theme) || THEME_OPTIONS[0]).Icon;

  useEffect(() => {
    const frame = requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    return () => cancelAnimationFrame(frame);
  }, [theme]);

  const destroyUserSession = () => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/users/sign_out.json")
      .then(({ data }) => {
        window.location.replace(data.redirect_url);
      });
  };

  const switchCurrentTeam = (teamId) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post(`/teams/${teamId}/switch_current.json`)
      .then(({ data }) => {
        window.location.replace("/dashboard");
      });
  };

  return (
    <div className="row m-0 user-menu">
      <div className="col-12 p-0"
            style={{
              "background": "var(--od-surface, white)",
              "borderTopRightRadius": "12px",
              "borderTopLeftRadius": "12px",
              "borderBottomRightRadius": "16px",
              "borderBottomLeftRadius": "16px",
              "boxShadow": "0 0 0 1px var(--od-border-2, #E9EAEB)"
            }}>
        <div className='position-relative text-left'
              style={{"margin": "12px"}}>
          <a href="/users/edit"
            style={{"fontWeight": "600"}}
            className="text-dark stretched-link">
            <i className="fal fa-user fa-fw"
                aria-hidden
                style={{"marginRight": "10px", "fontSize": "16px"}}></i>
            View Profile
          </a>
        </div>
        {myTicketsLink && myTicketsLink.href && (
          <div className='position-relative text-left' style={{"margin": "12px"}}>
            <a href={myTicketsLink.href}
              style={{"fontWeight": "600"}}
              className="text-dark stretched-link">
              <i className="fal fa-ticket fa-fw"
                  aria-hidden
                  style={{"marginRight": "10px", "fontSize": "16px"}}></i>
              {myTicketsLink.toolTip || "My Tickets"}
            </a>
          </div>
        )}
        <div className="position-relative text-left" data-testid="user-menu-theme">
          <div className="user-menu-theme-label">
            <CurrentThemeIcon />
            <span>Theme</span>
          </div>
          <div className="user-menu-theme-controls">
            <div className="user-menu-segmented" role="radiogroup" aria-label="Theme">
              {THEME_OPTIONS.map(({ value, label, Icon }) => (
                <button
                  key={value}
                  type="button"
                  role="radio"
                  aria-checked={theme === value}
                  className={`user-menu-segmented-item${theme === value ? ' active' : ''}`}
                  onClick={() => setTheme(value)}
                  data-testid={`theme-option-${value}`}
                >
                  <Icon />
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
        {teamMemberships.length > 1 ? (
          <div className="col-12"
                style={{
                  "borderTop": "1px solid var(--od-border-2, #E9EAEB)",
                  "padding": "8px 15px"
                }}>
            <div className='row position-relative'>
              <div className='col d-flex' style={{"padding": "0px 11px"}}>
                <div style={{"flexGrow": "1"}}>
                  <p className='text-muted mb-0 text-left'
                      style={{"fontSize": "12px", "fontWeight": "600", "marginTop": "3px"}}>
                    Switch team
                  </p>
                </div>
              </div>
            </div>
            <div className='row' style={{"marginTop": "4px", "marginBottom": "2px"}}>
              <div className='col-12'
                    style={{
                      "maxHeight": "170px",
                      "overflowY": "auto",
                      "padding": "0px 5px"
                    }}>
                {teamMemberships.sort((a, b) => a.team_name.localeCompare(b.team_name)).map((teamMembership, index) => (
                  <a key={index}
                      href="#"
                      onClick={
                        (e) => {
                          e.preventDefault();

                          if (teamMembership.current) {
                            return false;
                          }

                          switchCurrentTeam(teamMembership.team_id);
                        }
                      }
                      style={{
                        "padding": "5px 6px",
                        "borderRadius": "4px",
                        "background": (teamMembership.current ? "var(--od-c-fafafa, #fafafa)" : "transparent"),
                        "marginBottom": "2px"
                      }}
                      className={"main-menu-link text-truncate text-dark d-flex justify-content-between align-items-center position-relative"}>
                    <span style={{"fontWeight": "600"}}>
                      {teamMembership.team_name}
                    </span>
                    <div className="custom-control custom-radio position-absolute"
                          style={{"right": "-5px"}}>
                      <input type="radio"
                              id={`select-team-${teamMembership.team_id}`}
                              checked={teamMembership.current}
                              onChange={
                                (e) => {
                                  e.preventDefault();
                                }
                              }
                              className="custom-control-input" />
                      <label className="custom-control-label"
                              htmlFor={`select-team-${teamMembership.team_id}`}>
                        &nbsp;
                      </label>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="col-12 p-0">
        <div className='position-relative text-left'
              style={{"margin": "12px"}}>
          <a href="#"
            style={{"fontWeight": "600"}}
            onClick={
                (e) => {
                  e.preventDefault();
                  destroyUserSession();
                }
            }
            className="text-muted stretched-link">
            <i className="far fa-sign-out fa-fw"
                aria-hidden
                style={{"marginRight": "10px", "fontSize": "16px"}}></i>
            Sign Out
          </a>
        </div>
      </div>
    </div>
  )
};

UserMenu.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  currentUser: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  myTicketsLink: PropTypes.object,
  teamMemberships: PropTypes.array.isRequired
};
UserMenu.defaultProps = { myTicketsLink: {} };

export default UserMenu;
